import React, { createContext, useContext, useState } from "react";

export interface LoadingContextType {
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}

export const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [loadingCounter, setLoadingCounter] = useState(0);
  const isLoading = loadingCounter > 0;
  const setIsLoading = (loading: boolean) => {
    if (loading) {
      setLoadingCounter(loadingCounter => loadingCounter + 1);
    } else {
      setLoadingCounter(loadingCounter => loadingCounter - 1);
    }
  };
  return <LoadingContext.Provider value={{ isLoading, setIsLoading }}>{children}</LoadingContext.Provider>;
};

export const useLoading = (): LoadingContextType => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }
  return context;
};

// HOC for class components
export const withLoading = <P extends object>(WrappedComponent: React.ComponentType<P & LoadingContextType>) => {
  return function WithLoadingComponent(props: P) {
    const loading = useLoading();
    return <WrappedComponent {...props} {...loading} />;
  };
};
